import {Feature, FeatureCollection} from 'geojson';
import React, {useMemo} from 'react';
import {Source} from 'react-mapbox-gl';

export interface SimpleGeoJSONSourceProps {
    id: string;
    data: Feature | FeatureCollection;
}

export function SimpleGeoJSONSource(props: SimpleGeoJSONSourceProps) {
    const geoJsonSource = useMemo(() => ({
        type: 'geojson',
        data: props.data
    }), [props.data]);
    return (
        <Source
            id={props.id}
            geoJsonSource={geoJsonSource}
        />
    );
}
